export const COLORS = {
  brandPurple: "#714B67",
  brandPurpleLight: "#8B6E8F",
  brandTeal: "#017E84",
  lightGray: "#f9fafb",
  borderGray: "#edf2f7",
  textDark: "#1A202C",
  textMuted: "#4A5568",
  bgLight: "#F4F6FA",
  textGray: "#555",
  white: "#FFFFFF",
};

export const navLinkStyle: React.CSSProperties = {
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: 500,
  transition: "0.2s color ease",
  textDecoration: "none",
  color: "#4A5568",
  whiteSpace: "nowrap", // Prevents text from breaking into 2 lines
  margin: "0 12px",
};

export const SHARED_STYLES = {
  bannerContainer: {
    padding: "12px 20px",
    borderRadius: "10px",
    marginBottom: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  bannerButton: {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "none",
    background: "#714B67", // brandPurple
    color: "white",
    cursor: "pointer",
  },

  // ✅ Added reusable close button style
  bannerCloseButton: {
    position: "absolute" as const,
    right: "6px",
    top: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 700 as const,
    color: "#FF6A00",
    transition: "0.2s ease",
    lineHeight: 1,
    padding: "2px",
    borderRadius: "4px",
  },

  cardShadow: "0 5px 15px rgba(0,0,0,0.05)",
};
